import React from 'react'

const Lesson = () => {
  return (
    <div>
        <h1>Lesson Reminder</h1>
    </div>
  )
}

export default Lesson
